import { z } from "zod";

export const CreateStripeCheckoutSessionSchema = z.object({
	productId: z.string(),
	priceId: z.string(),
	fptid: z.string().optional(),
});

export const CreateStripeCheckoutSessionResponseSchema = z.object({
	sessionId: z.string(),
	sessionUrl: z.string(),
});

export type CreateStripeCheckoutSession = z.infer<typeof CreateStripeCheckoutSessionSchema>;

export type CreateStripeCheckoutSessionResponse = z.infer<
	typeof CreateStripeCheckoutSessionResponseSchema
>;

export const FinalizeStripeCheckoutSessionSchema = z.object({
	sessionId: z.string(),
});

export const FinalizeStripeCheckoutSessionResponseSchema = z.object({
	success: z.boolean(),
	// True when the payment is still processing (e.g. SEPA) but credits were already granted.
	// Optional so a newer frontend tolerates an older API (rolling deploy) that omits it.
	paymentPending: z.boolean().optional(),
});

export type FinalizeStripeCheckoutSession = z.infer<typeof FinalizeStripeCheckoutSessionSchema>;

export type FinalizeStripeCheckoutSessionResponse = z.infer<
	typeof FinalizeStripeCheckoutSessionResponseSchema
>;
